export const load = () => ({
	title: 'Secondary Glazing for Commercial Buildings',
	h1: 'Stop Replacing Your Windows. Start Upgrading Them.',
	description:
		'Gain R-18 energy efficiency & STC 50+ noise reduction without window replacement. Indow secondary glazing is non-destructive for hotels, offices, and schools.',
	showTitle: true,
});
